<template>
  <div class="grouped-log-details">
    <div class="columns">
      <div class="column is-full">
        <div class="columns" v-if="!isProjectSummaryHoursValid(this.selected_grouped_log.grouped_log)">
          <div class="column is-half">
            <b-message type="is-danger" has-icon>
              {{ this.$t('project-summary-view.invalid-summary-notice') }}
            </b-message>
          </div>
        </div>
        <div class="columns is-vcentered" style="margin-top: 2px; margin-left: 2px">
          <div class="column is-narrow" style="background: #ededed">
            <b-icon icon="format-list-checks" size="is-medium"/>
          </div>
          <div class="column is-narrow">
            <p class="title is-5">
              {{ this.$t('grouped-log-details.tasks-title') }}
            </p>
          </div>
        </div>
        <b-table :data="this.selected_grouped_log.grouped_log.tasks" :striped="true"
                 :mobile-cards="false" :loading="isLoading" :scrollable="true"
                 :show-header="true">
          <b-table-column field="task_title" v-slot="props" :label="this.$t('grouped-log-details.task-title-column')">
            {{ props.row.title }}
          </b-table-column>
          <b-table-column field="internal_duration" v-slot="props"
                          :label="this.$t('grouped-log-details.internal-duration-column')">
            <p class="internal-text">{{ getFormattedTimeHour(props.row.logged_durations_internal) }}</p>
          </b-table-column>
          <b-table-column field="external_duration" v-slot="props"
                          :label="this.$t('grouped-log-details.external-duration-column')">
            <p class="external-text">{{ getFormattedTimeHour(props.row.logged_durations_external) }}</p>
          </b-table-column>
          <b-table-column field="logged_quantities" v-slot="props" :label="this.$t('grouped-log-details.quantity-column')">
            <p>{{ getFormattedQuantity({quantity: props.row.logged_quantities}, props.row.unit) }}</p>
          </b-table-column>
          <b-table-column field="expected_quantities" v-slot="props"
                          :label="this.$t('grouped-log-details.expected-quantity-column')">
            <p>{{ getFormattedQuantity({quantity: props.row.expected_quantities}, props.row.unit) }}</p>
          </b-table-column>
          <b-table-column field="expected_performance" v-slot="props"
                          :label="this.$t('grouped-log-details.performance-column')">
            <p>{{ getFormattedPerformance(props.row.expected_performance, props.row.unit) }}</p>
          </b-table-column>
          <b-table-column field="profit" v-slot="props" :label="this.$t('grouped-log-details.profit-column')">
            <p :style="profitTextStyle(props.row.profit)">{{ getFormattedPricing(props.row.profit) }}</p>
          </b-table-column>
        </b-table>
        <div class="columns is-vcentered" style="margin-top: 40px; margin-left: 2px">
          <div class="column is-narrow" style="background: #ededed">
            <b-icon icon="account-hard-hat" size="is-medium"/>
          </div>
          <div class="column is-narrow">
            <p class="title is-5">
              {{ this.$t('grouped-log-details.personnel-title') }}
            </p>
          </div>
        </div>
        <b-table :data="this.selected_grouped_log.grouped_log.personnel" :striped="true"
                 :mobile-cards="false" :loading="isLoading" :scrollable="true"
                 :show-header="true">
          <b-table-column field="personal_name" v-slot="props"
                          :label="this.$t('grouped-log-details.personal-name-column')">
            {{ getFullName(props.row.name) }}
          </b-table-column>
          <b-table-column field="logged_quantities" v-slot="props"
                          :label="this.$t('grouped-log-details.personal-quantity-column')">
            <p :class="personalQuantityTextStyle(props.row.group)">{{ getFormattedTimeHour(props.row.logged_quantities) }}</p>
          </b-table-column>
          <b-table-column field="personal_agency" v-slot="props"
                          :label="this.$t('grouped-log-details.personal-agency-column')">
            {{ props.row.agency }}
          </b-table-column>
        </b-table>
        <div class="columns is-full" style="background: #ededed; margin-top: 60px; margin-left: 2px; margin-right: 2px">
          <div class="column is-full">
            <div class="columns">
              <div class="column is-narrow">
                <p style="width: 180px">{{ this.$t('grouped-log-details.tasks-total-hours') }}</p>
              </div>
              <div class="column is-narrow">
                <p class="internal-text" style="width: 80px">{{
                    getFormattedTimeHour(this.selected_grouped_log.grouped_log.total_logged_durations_internal)
                  }}</p>
              </div>
              <div class="column is-narrow">
                <p class="external-text" style="width: 80px">{{
                    getFormattedTimeHour(this.selected_grouped_log.grouped_log.total_logged_durations_external)
                  }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-narrow">
                <p style="width: 180px">{{ this.$t('grouped-log-details.personnel-total-hours') }}</p>
              </div>
              <div class="column is-narrow">
                <p class="internal-text" style="width: 80px">
                  {{ getFormattedTimeHour(this.selected_grouped_log.grouped_log.total_logged_durations_internal_personnel) }}</p>
              </div>
              <div class="column is-narrow">
                <p class="external-text" style="width: 80px">
                  {{ getFormattedTimeHour(this.selected_grouped_log.grouped_log.total_logged_durations_external_personnel) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupedLogDetails",
  components: {},
  props: {
    'selected_grouped_log': {
      grouped_log: {}
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
    console.log("selected_grouped_log", this.selected_grouped_log)
  }
}
</script>

<style scoped>
</style>
